import { getLocalStorageItem, sensesCoreApiPrefixKey } from './utils';

const applyTheme = (theme: string): void => {
  const bodyElement = document.querySelector('body');
  bodyElement.dataset.sfcTheme = theme;
};

const getSystemThemeWeb = (): string =>
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';

const isThemeAvailableWeb = (): boolean => !!window.matchMedia;

const getThemeSettingsWeb = () => {
  const system = getSystemThemeWeb();
  const preference = getLocalStorageItem(sensesCoreApiPrefixKey('theme'));
  const theme = preference || system;
  return { system, preference, theme };
};

export const setThemeWeb = (): void => {
  if (!isThemeAvailableWeb) {
    return;
  }
  const themeSettingsWeb = getThemeSettingsWeb();
  applyTheme(themeSettingsWeb.theme);
};

export const isDarkMode = (): boolean =>
  !!document.querySelector('body[data-sfc-theme=dark]') ||
  !!document.querySelector('html[data-sfc-theme=dark]');
